import { authAction } from '../modules';
import { clearStorageRetainCookies } from '../../utils/storageHelper';

// Token yenileme işlemi için durum yönetimi
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

/**
 * Handles authentication-related actions such as token refresh and logout.
 */
export const handleAuthenticated =
  ({ dispatch }) =>
  (next) =>
  async (action) => {
    const { payload } = action;

    const requestUrl = payload?.error?.config?.url || "";
    const isPublicRequest = requestUrl.includes("/public/");

    // Public akışlardaki (login, şifremi unuttum, yeni şifre belirleme)
    // 401/403 yanıtları bir oturum sonlanması değil, iş kuralı/yetki
    // hatasıdır. Bunları global olarak ele alma; ilgili sayfa yönetir.
    if (payload?.status === 401 && !isPublicRequest) {
      const token = localStorage.getItem("token");
      const refreshToken = localStorage.getItem("refreshToken");

      if (token && refreshToken) {
        if (isRefreshing) {
          // Eğer token yenileme işlemi devam ediyorsa, kuyruğa al
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          });
        }

        isRefreshing = true;

        try {
          const res = await dispatch(
            authAction.refreshToken(token, refreshToken)
          );
          if (res.token) {
            localStorage.setItem("token", res.token);
            localStorage.setItem("refreshToken", res.refreshToken);
            processQueue(null, res.token);
            // window.location.replace yerine history API kullanıyoruz
            if (window.history && window.history.replaceState) {
              window.history.replaceState(null, '', '/home');
              window.dispatchEvent(new PopStateEvent('popstate'));
            }
          }
        } catch (error) {
          console.error("Token refresh error: ", error);
          processQueue(error, null);
          dispatch(authAction.logout(token, refreshToken));
        } finally {
          isRefreshing = false;
        }
      }
    } else if (payload?.status === 403 && !isPublicRequest) {
      clearStorageRetainCookies();
      // window.location.replace yerine history API kullanıyoruz
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '/login');
        window.dispatchEvent(new PopStateEvent('popstate'));
      }
    } else {
      next(action);
    }
  };
